import { render, staticRenderFns } from "./appltPickuppoint.vue?vue&type=template&id=fc4540ea&scoped=true"
import script from "./appltPickuppoint.vue?vue&type=script&lang=js"
export * from "./appltPickuppoint.vue?vue&type=script&lang=js"
import style0 from "./appltPickuppoint.vue?vue&type=style&index=0&id=fc4540ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4540ea",
  null
  
)

export default component.exports